import { colors } from '../../colors';
var form = {
  bgColor: colors.offWhite,
  labelColor: colors.charcoalGrey,
  errorColor: colors.warningRed,
  borderColor: colors.charcoalGrey,
  linkColor: colors.dustyTeal,
  documentFormBgColor: colors.offWhite,
  textColorDark: colors.charcoalGrey,
  textColorLight: colors.white
};
export default form;